var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{key:_vm.src,attrs:{"width":_vm.width,"autoplay":"","muted":"","playsinline":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.src,"type":_vm.type}})])
}
var staticRenderFns = []

export { render, staticRenderFns }